// extracted by mini-css-extract-plugin
export default {"asset-split-inputs":"styles_asset-split-inputs__AHs-B","asset-value-label":"styles_asset-value-label__FQL44"};